module.exports = __webpack_public_path__ + "images/emoji/cupid.119b995f5a570ec73142.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cupid.png
// module id = DS2o
// module chunks = 1